export default "__VITE_ASSET__C6WYPE8J__"